import { css } from '@emotion/css';
import { media } from 'src/components/Framework';
import Logo from 'src/images/popper-logo-outlined.svg';
import * as React from 'react';
export default {
  css,
  media,
  Logo,
  React
};